import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { DailyCropDetailsReport } from './Pages/listing';

export const DailyCropDetailsReportRoutes = ({ match }) => (
    <Fragment>
        <Route exact path={`${match.path}`} component={DailyCropDetailsReport} />
    </Fragment>
)